/* Cart drawer behaviour on top of Impulse's CartDrawer/CartForm: removal, inline errors,
   busy state, focus return, count and savings, theme editor preview. */
(function () {
  if (window.jpCartDrawer) return;
  function nextFocusKey(keys, removed) {
    var i = keys.indexOf(removed);
    if (i === -1) return null;
    return keys[i + 1] || keys[i - 1] || null;
  }
  function fillAmount(tpl, amount) {
    return (tpl || '').replace('[amount]', '<strong>' + amount + '</strong>');
  }
  function parseCartResponse(text) {
    var cart;
    try { cart = JSON.parse(text); } catch (e) { throw new Error('Invalid cart response'); }
    if (!cart || cart.status || !Array.isArray(cart.items) || !Number.isFinite(cart.item_count)) {
      throw new Error(cart && (cart.description || cart.message) || 'Invalid cart response');
    }
    return cart;
  }
  window.jpCartDrawer = { nextFocusKey: nextFocusKey, fillAmount: fillAmount, parseCartResponse: parseCartResponse };

  if (!document.documentElement.classList) return; // node test stub

  function drawer() { return document.querySelector('[data-jp-cd]'); }
  function money(cents) {
    return window.theme && theme.Currency ? theme.Currency.formatMoney(cents, theme.settings.moneyFormat) : (cents / 100).toFixed(2);
  }
  var pending = false;
  var awaitingRender = false;
  var renderTimer = null;
  var activeKey = null;
  var activeWrapper = null;
  function busy(value) {
    pending = value;
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-busy', pending);
    var form = d.querySelector('form');
    if (form) form.setAttribute('aria-busy', pending ? 'true' : 'false');
    d.querySelectorAll('.js-qty__adjust, .js-qty__num, .cart__checkout').forEach(function (el) { el.disabled = pending; });
    d.querySelectorAll('[data-jp-remove]').forEach(function (el) {
      if (pending) { el.setAttribute('aria-disabled', 'true'); el.setAttribute('tabindex', '-1'); }
      else { el.removeAttribute('aria-disabled'); el.removeAttribute('tabindex'); }
    });
    var checkout = d.querySelector('.cart__checkout');
    if (checkout) checkout.classList.toggle('btn--loading', pending);
  }
  function release() {
    clearTimeout(renderTimer);
    awaitingRender = false;
    if (activeWrapper) activeWrapper.classList.remove('is-loading');
    activeKey = null;
    activeWrapper = null;
    busy(false);
  }
  function waitForRender() {
    awaitingRender = true;
    renderTimer = setTimeout(function () {
      showError();
      release();
    }, 10000);
  }
  function restoreQuantity() {
    var wrapper = activeWrapper;
    if (!wrapper) return;
    var input = wrapper.querySelector('.js-qty__num');
    if (input) input.value = input.getAttribute('value');
    wrapper.classList.remove('is-loading');
  }
  function showError(msg) {
    var d = drawer();
    var el = d && d.querySelector('[data-jp-cd-error]');
    if (!el) return;
    el.textContent = msg || d.dataset.errorText;
    el.hidden = false;
  }
  function clearError() {
    var d = drawer();
    var el = d && d.querySelector('[data-jp-cd-error]');
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  /* Reject invalid responses before Impulse treats them as a successful cart. */
  function wrapChangeItem() {
    if (!window.theme || !theme.cart || theme.cart.jpWrapped) return;
    var original = theme.cart.changeItem.bind(theme.cart);
    theme.cart.changeItem = function (key, qty) {
      if (!document.documentElement.classList.contains('js-drawer-open') || !drawer()) return original(key, qty);
      if (pending) return Promise.reject(new Error('Cart change in progress'));
      activeKey = key;
      busy(true);
      clearError();
      return original(key, qty).then(function (text) {
        parseCartResponse(text);
        waitForRender();
        return text;
      }).catch(function (error) {
        showError(error.message);
        restoreQuantity();
        changedKey = null;
        release();
        throw error;
      });
    };
    theme.cart.jpWrapped = true;
  }

  /* Removal: Impulse ignores quantity 0 and the remove link reloads /cart */
  var focusKey = null;
  var changedKey = null;
  function itemKeys(d) {
    return Array.prototype.map.call(d.querySelectorAll('.cart__item[data-key]'), function (el) { return el.getAttribute('data-key'); });
  }
  function removeItem(key) {
    var d = drawer();
    if (!d || pending) return;
    var item = d.querySelector('.cart__item[data-key="' + CSS.escape(key) + '"]');
    if (!item || item.classList.contains('is-removing')) return;
    focusKey = nextFocusKey(itemKeys(d), key) || '__title';
    item.style.height = item.offsetHeight + 'px';
    void item.offsetHeight;
    item.classList.add('is-removing');
    theme.cart.changeItem(key, 0).then(function (text) {
      var cart = parseCartResponse(text);
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function () {
      item.classList.remove('is-removing');
      item.style.height = '';
      focusKey = null;
      release();
    });
  }
  window.addEventListener('cart:quantity.cart-cart-drawer', function (e) {
    var detail = e.detail || [];
    if (!detail[0] || !drawer() || !document.documentElement.classList.contains('js-drawer-open')) return;
    if (pending) {
      e.stopImmediatePropagation();
      var blockedInput = detail[2] && detail[2].querySelector('.js-qty__num');
      if (blockedInput) blockedInput.value = blockedInput.getAttribute('value');
      return;
    }
    if (Number(detail[1]) === 0) {
      e.stopImmediatePropagation();
      removeItem(detail[0]);
    } else {
      changedKey = detail[0];
      activeWrapper = detail[2] || null;
    }
  }, true);
  function bindFormSubmit() {
    var d = drawer();
    var form = d && d.querySelector('#CartDrawerForm');
    if (!form || form.jpSubmitGuard) return;
    form.jpSubmitGuard = true;
    form.addEventListener('submit', function (e) {
      if (!pending) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);
  }
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-jp-cd] [data-jp-remove]');
    if (!link) return;
    e.preventDefault();
    removeItem(link.getAttribute('data-jp-remove'));
  });

  /* After every rebuild of [data-products]: quantity tick and focus after removal */
  function afterRebuild() {
    var d = drawer();
    if (!d) return;
    if (awaitingRender) release();
    if (changedKey) {
      var num = d.querySelector('.cart__item[data-key="' + CSS.escape(changedKey) + '"] .js-qty__num');
      if (num) { num.classList.remove('is-ticked'); void num.offsetWidth; num.classList.add('is-ticked'); }
      changedKey = null;
    }
    if (focusKey) {
      var target = focusKey === '__title' ? null : d.querySelector('.cart__item[data-key="' + CSS.escape(focusKey) + '"] .cart__item-name');
      if (!target) target = d.classList.contains('is-empty') ? d.querySelector('.jp-cd__empty-btn') || d.querySelector('.js-drawer-close') : d.querySelector('.js-drawer-close');
      if (target) target.focus({ preventScroll: true });
      focusKey = null;
    }
  }

  /* Count, savings and original total follow the real cart */
  function renderTotals(cart) {
    var d = drawer();
    if (!d) return;
    d.querySelectorAll('[data-jp-cd-count]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
    var savings = d.querySelector('[data-jp-cd-savings]');
    if (savings) {
      savings.hidden = !(cart.total_discount > 0);
      savings.querySelector('[data-jp-cd-savings-text]').innerHTML = fillAmount(savings.dataset.text, money(cart.total_discount));
    }
    var original = d.querySelector('[data-jp-cd-original]');
    if (original) {
      original.hidden = !(cart.total_discount > 0);
      original.textContent = money(cart.original_total_price);
    }
  }
  document.addEventListener('jp:cart', function (e) { renderTotals(e.detail.cart); reserveCount(e.detail.cart.item_count); });

  /* Reserve countdown: visual urgency only, never clears the cart */
  var reserveTimer = null;
  function reserveRow() { var d = drawer(); return d && d.querySelector('[data-jp-cd-reserve]'); }
  function reserveStart(count) {
    var start = null;
    try {
      if (count > 0) {
        start = Number(localStorage.getItem('jpCartReserveStart'));
        if (!start) { start = Date.now(); localStorage.setItem('jpCartReserveStart', String(start)); }
      } else localStorage.removeItem('jpCartReserveStart');
    } catch (e) { /* storage blocked: fall back to this page view */ }
    return start;
  }
  var memStart = null;
  function reserveTick() {
    var row = reserveRow();
    if (!row || row.hidden) return;
    var left = Math.round(Number(row.dataset.minutes) * 60 - (Date.now() - row.jpStart) / 1000);
    var label = row.querySelector('[data-jp-cd-reserve-text]');
    row.classList.toggle('is-expired', left <= 0);
    row.classList.toggle('is-urgent', left > 0 && left < 120);
    if (left <= 0) { label.textContent = row.dataset.expired; return; }
    var mm = String(Math.floor(left / 60)).padStart(2, '0'), ss = String(left % 60).padStart(2, '0');
    var parts = row.dataset.text.split('[time]'), time = document.createElement('b');
    time.textContent = mm + ':' + ss;
    label.textContent = parts[0];
    if (parts.length > 1) { label.appendChild(time); label.appendChild(document.createTextNode(parts.slice(1).join('[time]'))); }
  }
  function reserveCount(count) {
    var row = reserveRow();
    if (!row) return;
    row.dataset.count = count;
    row.hidden = !(count > 0);
    clearInterval(reserveTimer);
    var start = reserveStart(count);
    if (count > 0) {
      if (!start) { memStart = memStart || Date.now(); start = memStart; } else memStart = null;
      row.jpStart = start;
      reserveTick();
      reserveTimer = setInterval(reserveTick, 1000);
    } else memStart = null;
  }

  /* Focus return when add to cart opened the drawer (Impulse only restores click sources) */
  var trigger = null;
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.add-to-cart, [name="add"]');
    if (btn) trigger = btn;
  }, true);
  function watchClose() {
    var html = document.documentElement;
    var wasOpen = html.classList.contains('js-drawer-open');
    var entranceTimer = null;
    new MutationObserver(function () {
      var open = html.classList.contains('js-drawer-open');
      if (!wasOpen && open) {
        var d = drawer();
        if (d) {
          d.classList.add('is-entering');
          clearTimeout(entranceTimer);
          entranceTimer = setTimeout(function () { d.classList.remove('is-entering'); }, 500);
        }
      }
      if (wasOpen && !open) {
        clearTimeout(entranceTimer);
        var closedDrawer = drawer();
        if (closedDrawer) closedDrawer.classList.remove('is-entering');
      }
      if (wasOpen && !open && trigger && trigger.isConnected) {
        var active = document.activeElement;
        if (!active || active === document.body) trigger.focus({ preventScroll: true });
        trigger = null;
      }
      wasOpen = open;
    }).observe(html, { attributes: true, attributeFilter: ['class'] });
  }

  function observeProducts() {
    var d = drawer();
    var list = d && d.querySelector('[data-products]');
    if (!list || list.jpObserved) return;
    list.jpObserved = true;
    new MutationObserver(afterRebuild).observe(list, { childList: true });
  }

  /* Theme editor: select opens, deselect closes, reload re-binds Impulse to the new markup */
  function isDrawerSection(e) { return e.target && e.target.querySelector && e.target.querySelector('[data-jp-cd]'); }
  document.addEventListener('shopify:section:select', function (e) { if (isDrawerSection(e)) document.dispatchEvent(new CustomEvent('cart:open')); });
  document.addEventListener('shopify:section:deselect', function (e) { if (isDrawerSection(e)) document.dispatchEvent(new CustomEvent('cart:close')); });
  document.addEventListener('shopify:section:load', function (e) {
    if (!isDrawerSection(e) || !window.theme || !theme.CartDrawer) return;
    // ponytail: the previous CartDrawer keeps its document listeners on detached nodes; editor only, a page reload clears it
    new theme.CartDrawer();
    bindFormSubmit();
    observeProducts();
    if (window.jpProgress) jpProgress.renderAll();
    var row = reserveRow();
    if (row) reserveCount(Number(row.dataset.count));
  });

  function init() {
    wrapChangeItem();
    bindFormSubmit();
    observeProducts();
    watchClose();
    var row = reserveRow();
    if (row) reserveCount(Number(row.dataset.count));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
